import { baseApi } from "app/baseApi";
import { apiTags } from "app/store/apiTags";

const apiPrefix = 'vendorDetachedTemplate';
export const vendorDetachedTemplateApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getVendorDetachedTemplate: builder.query({
            query: (vendorId) => `${apiPrefix}?vendorId=${vendorId}`,
            providesTags: [apiTags.VENDOR_DETACHED_TEMPLATE]
        }),
        createVendorDetachedTemplate: builder.mutation({
            query: ({ vendorId, subject, body }) => ({
                url: `${apiPrefix}?vendorId=${vendorId}`,
                method: "POST",
                body: { subject, body }
            }),
            invalidatesTags: [apiTags.VENDOR_DETACHED_TEMPLATE]
        }),
        updateVendorDetachedTemplate: builder.mutation({
            query: ({ vendorId, subject, body }) => ({
                url: `${apiPrefix}?vendorId=${vendorId}`,
                method: "PUT",
                body: { subject, body }
            }),
            invalidatesTags: [apiTags.VENDOR_DETACHED_TEMPLATE]
        }),
        sendVendorEmail: builder.mutation({
            query: ({ vendorId, workOrderId, templateSubject, templateBody }) => ({
                url: `${apiPrefix}/sendEmail`,
                method: "POST",
                body: { vendorId, workOrderId, templateSubject, templateBody }
            }),
        }),
    })
});

export const {
    useGetVendorDetachedTemplateQuery,
    useCreateVendorDetachedTemplateMutation,
    useUpdateVendorDetachedTemplateMutation,
    useSendVendorEmailMutation,
} = vendorDetachedTemplateApi;
